export const Types = {
    SEARCH_RESULT: "SEARCH_RESULT",
  };